if (!customElements.get("pickup-availability")) {
  customElements.define(
    "pickup-availability",
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute("available")) return;

        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
        this.isInStoreOnly = this.dataset.inStoreOnly;
        this.svgAvailable = this.querySelector(".svg-wrapper").dataset.svgAvailable;
      }
      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector("button");
            if (button) button.removeEventListener("click", this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = "";

        if (this.querySelector("button")) {
          this.querySelector("button").addEventListener("click", this.onClickRefreshList);
        }
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector(".pickup-availability-drawer");
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector(".pickup-availability-information")) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }

        if (this.isInStoreOnly && sectionInnerHTML.querySelector("#pickup_availability__title")) {
          if (this.isInStoreOnly && this.svgAvailable === "true") {
            sectionInnerHTML.querySelector("#pickup_availability__title").innerHTML = "Available in store at";
          } else if (this.isInStoreOnly && this.svgAvailable === "false") {
            sectionInnerHTML.querySelector("#pickup_availability__title").innerHTML = "Not currently available in store at";
          }

          if (sectionInnerHTML.querySelectorAll("#drawer-pick-availability__title")) {
            sectionInnerHTML.querySelectorAll("#drawer-pick-availability__title").forEach((el) => {
              el.innerHTML = "Available in store";
              el.classList.remove("bg-[#F0F2F8]");
              el.classList.add("bg-[#DEFADE]");
            });
          }

          if (sectionInnerHTML.querySelectorAll("#drawer-pick-availability__header")) {
            sectionInnerHTML.querySelectorAll("#drawer-pick-availability__header").forEach((el) => el.remove());
          }

          if (sectionInnerHTML.querySelectorAll("#drawer-not-pick-availability__title")) {
            sectionInnerHTML.querySelectorAll("#drawer-not-pick-availability__title").forEach((el) => (el.innerHTML = "Not currently available in store"));
          }

          if (sectionInnerHTML.querySelectorAll("#pickup-availability-information__header")) {
            sectionInnerHTML.querySelectorAll("#pickup-availability-information__header").forEach((el) => (el.innerHTML = "Find in Store"));
          }
        }

        this.innerHTML = sectionInnerHTML.querySelector(".pickup-availability-information").innerHTML;
        this.setAttribute("available", "");

        document.getElementById("Pickup-Availability").innerHTML = sectionInnerHTML.querySelector(".side-availability").innerHTML;

        const button = this.querySelector("button");
        if (button)
          button.addEventListener("click", (evt) => {
            if (this.isInStoreOnly) {
              if (document.querySelector(".hidden-in-store-only-product")) {
                document.querySelector(".hidden-in-store-only-product").remove();
              }
              document.querySelector(".partial-hidden-in-store-only-product").innerText = "Find in Store";
            }
            document.getElementById("Pickup-Availability").classList.toggle("active");
            document.getElementsByTagName("body")[0].classList.toggle("open-cc");

            evt.preventDefault();
          });
      }
    }
  );
}
